import { Suspense, lazy } from "react";

import { useChatRoomGameContext } from "@/hooks";

// The panel (messages, emoji picker, tip dialogs) loads on the first open, not with every page.
const ChatRoomPanel = lazy(() => import("./ChatRoom").then((m) => ({ default: m.ChatRoom })));

export const ChatRoom = () => {
  const { open } = useChatRoomGameContext();
  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <ChatRoomPanel />
    </Suspense>
  );
};
